<template>
	<div class="store-month-statistic-container">
		<div class="section-header">
			<div class="header-line"></div>
			<span class="section-title">订单近30天数量统计</span>
		</div>
		<div class="chart-wrapper">
			<div ref="chartRef" class="statisticChart"></div>
		</div>
	</div>
</template>

<script>
import { GetStoreOrderNumMonthStatistics } from "@/api/storeOrderApi.js";
import * as echarts from "echarts";
export default {
	data() {
		return {
			loading: false,
			statisticData: {
				dayList: [],
				numList: []
			},
			chart: null
		};
	},
	components: {},

	created() {
		this.GetStoreOrderNumMonthStatistics();
	},

	mounted() {
		this.initChart();
	},

	beforeUnmount() {
		if (this.chart) {
			window.removeEventListener("resize", this.handleResize);
			this.chart.dispose();
			this.chart = null;
		}
	},

	methods: {
		handleResize() {
			if (this.chart) {
				this.chart.resize();
			}
		},
		initChart() {
			const chartDom = this.$refs.chartRef;
			this.chart = echarts.init(chartDom);
			this.updateChart();

			window.addEventListener("resize", this.handleResize);
		},
		updateChart() {
			const option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow"
					},
					backgroundColor: "rgba(255, 255, 255, 0.95)",
					borderColor: "#e2e8f0",
					borderWidth: 1,
					textStyle: {
						color: "#303133"
					},
					formatter: (params) => {
						const item = params[0];
						return `<div style="padding: 8px;">
              <div style="font-weight: 600; margin-bottom: 4px;">${item.name}</div>
              <div style="color: #409eff; font-size: 16px;">订单数量：<span style="font-weight: 700;">${item.value}</span></div>
            </div>`;
					}
				},
				grid: {
					left: "3%",
					right: "4%",
					bottom: "15%",
					top: "12%",
					containLabel: true
				},
				xAxis: {
					name: "日期",
					type: "category",
					data: this.statisticData.dayList,
					nameLocation: "end",
					nameGap: 10,
					nameTextStyle: {
						color: "#606266",
						fontSize: 12
					},
					axisLine: {
						lineStyle: {
							color: "#dcdfe6"
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						interval: 2,
						rotate: 30,
						color: "#606266",
						fontSize: 11
					}
				},
				yAxis: {
					type: "value",
					name: "订单数量",
					nameLocation: "end",
					nameGap: 10,
					nameTextStyle: {
						color: "#606266",
						fontSize: 12
					},
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					splitLine: {
						lineStyle: {
							color: "#f0f0f0",
							type: "dashed"
						}
					},
					axisLabel: {
						color: "#606266"
					}
				},
				series: [
					{
						name: "订单数量",
						type: "bar",
						data: this.statisticData.numList,
						barWidth: "50%",
						barMaxWidth: 35,
						itemStyle: {
							borderRadius: [4, 4, 0, 0],
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0,
									color: "#409eff"
								},
								{
									offset: 1,
									color: "#73c0de"
								}
							])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#2a6fc9"
									},
									{
										offset: 1,
										color: "#409eff"
									}
								])
							}
						},
						label: {
							show: true,
							position: "top",
							distance: 6,
							color: "#409eff",
							fontSize: 11,
							fontWeight: "600",
							formatter: "{c}"
						}
					}
				]
			};

			this.chart.setOption(option);
		},
		GetStoreOrderNumMonthStatistics() {
			let param = {};
			GetStoreOrderNumMonthStatistics(param).then((res) => {
				if (res.code == 1) {
					if (res.data) {
						this.statisticData.dayList = [];
						this.statisticData.numList = [];
						let list = res.data.dtls;
						list.forEach((item) => {
							this.statisticData.dayList.push(item.dateStr);
							this.statisticData.numList.push(item.count);
						});
						if (this.chart) {
							this.updateChart();
						}
					}
				} else {
					this.$message({
						type: "info",
						message: res.msg
					});
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.store-month-statistic-container {
	background: #ffffff;
	border-radius: 12px;
	padding: 16px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	width: 100%;
	height: 100%;
	min-height: 350px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	padding-bottom: 12px;
	border-bottom: 2px solid #f0f0f0;
}

.header-line {
	width: 4px;
	height: 22px;
	background: linear-gradient(180deg, #409eff 0%, #67c23a 100%);
	border-radius: 2px;
	margin-right: 12px;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	letter-spacing: 0.5px;
}

.chart-wrapper {
	flex: 1;
	min-height: 280px;
	display: flex;
	align-items: stretch;
}

.statisticChart {
	width: 100%;
	height: 100%;
	min-height: 280px;
}

@media (max-width: 768px) {
	.store-month-statistic-container {
		padding: 12px;
		min-height: 280px;
	}

	.chart-wrapper {
		min-height: 220px;
	}

	.statisticChart {
		min-height: 220px;
	}
}
</style>
